import { FunctionComponent, useState } from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { setShowSettingsMenu } from "./store/settingsSlice";
import { ActionsContext, LocalGameActions } from "./ActionsContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { resetLocalStore } from "./Utils";
import { setWipeTransition } from "./store/wipeTransitionSlice";
import { GameMode } from "./Types";
import RulesModal from "./RulesModal";

const GameHUD: FunctionComponent = () => {
  const dispatch  = useAppDispatch();
  const navigate  = useNavigate();
  const actions   = useContext(ActionsContext);
  const [showMenu, setShowMenu]   = useState(false);
  const [showRules, setShowRules] = useState(false);

  const profile    = useAppSelector((s) => s.user.profile);
  const matchScore = useAppSelector((s) => s.matchScore);
  const bet        = useAppSelector((s) => s.bet);
  const gameMode   = useAppSelector((s) => s.settings.gameMode);
  const isLocal    = actions instanceof LocalGameActions;

  const goToMenu = () => {
    setShowMenu(false);
    resetLocalStore(dispatch, true);
    dispatch(setWipeTransition(true));
    navigate("/");
  };

  return (
    <div className="HUD-wrapper">
      {/* Левая часть — баланс, ставка, очки матча */}
      <div className="HUD-left">
        {profile && (
          <div className="HUD-balance">
            <div className="HUD-balance-dot" />
            <span className="HUD-balance-val">{profile.coins.toLocaleString()} ₽</span>
          </div>
        )}
        {!isLocal && bet > 0 && (
          <div className="HUD-bet">
            <span className="HUD-bet-label">Ставка</span>
            <span className="HUD-bet-val">{bet} ₽</span>
            <span className="HUD-bet-payout">→ {Math.floor(bet * 2 * 0.8)} ₽</span>
          </div>
        )}
        <div className="HUD-score">
          {gameMode === GameMode.LongNardy && (
            <span className="HUD-score-mode">Длинные</span>
          )}
          <span>До {matchScore.pointsRequiredToWin} {matchScore.pointsRequiredToWin === 1 ? "очка" : "очков"}</span>
        </div>
      </div>

      {/* Правая часть — кнопки */}
      <div className="HUD-right">
        <button
          className="HUD-btn"
          onClick={() => dispatch(setShowSettingsMenu(true))}
          title="Настройки"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/>
          </svg>
        </button>

        <div className="HUD-menu-wrap">
          <button
            className="HUD-btn"
            onClick={() => setShowMenu(v => !v)}
            title="Меню"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6"/>
              <line x1="3" y1="12" x2="21" y2="12"/>
              <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          </button>

          {showMenu && (
            <>
              <div className="HUD-dropdown">
                {!isLocal && profile && (
                  <div className="HUD-dropdown-user">
                    <div className="HUD-dropdown-nick">{profile.nickname}</div>
                    <div className="HUD-dropdown-rating">Рейтинг: {profile.rating}</div>
                    <div className="HUD-dropdown-level">Ур. {profile.level}</div>
                  </div>
                )}
                <button className="HUD-dropdown-item" onClick={() => { dispatch(setShowSettingsMenu(true)); setShowMenu(false); }}>
                  Настройки
                </button>
                <button className="HUD-dropdown-item" onClick={() => { setShowRules(true); setShowMenu(false); }}>
                  Правила игры
                </button>
                <button className="HUD-dropdown-item danger" onClick={goToMenu}>
                  Выйти в меню
                </button>
              </div>
              <div className="HUD-backdrop" onClick={() => setShowMenu(false)} />
            </>
          )}
        </div>
      </div>
      {showRules && <RulesModal gameMode={gameMode} onClose={() => setShowRules(false)} />}
    </div>
  );
};

export default GameHUD;
